import React, { useEffect, useState } from 'react';
import { useHashTag } from '../../hooks/hashtag/useHashtag';
import AsideRight from './components/aside-right';
import { Helmet } from 'react-helmet-async';
import Profile from './components/profile';
import ProfileBanner from './components/profile-banner';
import { IOption } from '../../select/select.component';
import { fetchAllCity } from '../../api';
import _ from 'lodash';
import { useDating } from '../../hooks/use-dating/useDating';
import Connection from './components/connection';
import Albums from './components/albums';
import Requests from './components/requests';
import ProfileUseDating from './components/profile-user-dating';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChatPageDating } from './components/chat/chatDating';

export const DatingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [tabActive, setTabActive] = useState('connection');
  const [cities, setCities] = useState<IOption[]>([]);
  const {
    datingProfile,
    getDatingProfile,
    getMatchRequestsByProfileId,
    getDatingInfoByProfileId,
    matchRequests,
    datingInfo,
  } = useDating({});

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabFromUrl = params.get('tab');
    setTabActive(tabFromUrl || 'connection');
  }, [location.search]);
  const changeTab = (tab: string, profileId?: string) => {
    const params = new URLSearchParams();
    params.set('tab', tab);
    if (profileId) {
      params.set('id', profileId);
    }
    setTabActive(tab);
    navigate(`?${params.toString()}`, { replace: true });
  };

  const fetchCityOptions = async () => {
    try {
      const response = await fetchAllCity();
      const data: any = _.map(
        _.get(response, 'countries[0].cities', []),
        (item: any) => ({
          value: item.cityId,
          label: item.name,
        })
      );
      setCities(data);
    } catch (error) {
      console.error('Failed to fetch city options:', error);
    }
  };

  useEffect(() => {
    fetchCityOptions();
  }, []);

  useEffect(() => {
    if (datingProfile) {
      if (datingProfile.profileId) {
        getMatchRequestsByProfileId(datingProfile.profileId);
        getDatingInfoByProfileId(datingProfile.profileId);
      }
    }
  }, [datingProfile]);

  const refetchMatchRequests = () => {
    if (datingProfile?.profileId) {
      getMatchRequestsByProfileId(datingProfile.profileId);
    }
  };

  return (
    <div className=" h-100 px-6 py-2">
      <Helmet>
        <title>Cab VN</title>
        <meta name="home" content="Cab VN" />
      </Helmet>

      <div className=" flex gap-6 flex-col md:flex-row">
        <ProfileBanner
          datingInfo={datingInfo}
          getDatingProfile={getDatingProfile}
          cities={cities}
          tabActive={tabActive}
          changeTab={changeTab}
          profile={datingProfile}
          totalMatchRequests={matchRequests?.length}
        />

        <div className="w-full">
          {tabActive === 'profile' && (
            <ProfileUseDating
              getDatingProfile={getDatingProfile}
              cities={cities}
              profile={datingProfile}
            />
          )}
          {tabActive === 'connection' && <Connection changeTab={changeTab} />}
          {tabActive === 'album' && (
            <Albums
              profile={datingProfile}
              getDatingProfile={getDatingProfile}
            />
          )}
          {tabActive === 'requests' && (
            <Requests
              changeTab={changeTab}
              matchRequests={matchRequests}
              refetch={refetchMatchRequests}
            />
          )}
          {tabActive === 'chat' && <ChatPageDating />}
        </div>
      </div>
    </div>
  );
};
